
export const RADIKS_SERVER_URL = process.env.GITIX_RADIKS_SERVER
? process.env.GITIX_RADIKS_SERVER
: 'https://gitix.herokuapp.com'
